// extracted by mini-css-extract-plugin
export var messageSideLeft = "_lv-1";
export var messageSideRight = "_lv-2";
export var orderLookupBubbleContainer = "_lv-0";
export var submitButton = "_lv-3";